import { useEffect } from 'react';
import { Platform } from 'react-native';
import { isCapital } from '@/utils/utils';
import { useNotification } from '@/components/ui/therapist/Notification/NotificationProvider';

export interface KeyListenerProps {
  letter: string;
  correct: boolean;
  onCorrect: () => void;
  onWrong: () => void;
  order: number;
}

export const useKeyListener = ({
  letter,
  correct,
  onCorrect,
  onWrong,
  order,
}: KeyListenerProps) => {
  const { showNotification } = useNotification();

  useEffect(() => {
    if (Platform.OS === 'web') {
      const onKeyPress = (e: KeyboardEvent) => {
        const { key } = e;
        if (isCapital(letter) && key === letter.toLowerCase()) {
          showNotification({
            type: 'info',
            title: 'Erwägen Sie die Großschreibung',
          });
          return;
        }
        if (key === letter) correct ? onCorrect() : onWrong();
      };
      window.addEventListener('keypress', onKeyPress);

      return () => {
        window.removeEventListener('keypress', onKeyPress);
      };
    }
  }, [order, correct, letter]);
};
